
























































































































































































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { mapGetters } from 'vuex'
import LotImage from '@/components/consumer_map_v3/LotImage.vue'
import { LotInfo } from '~/models'
import { PublicProject } from '~/models/project'
import projectConfig from '~/assets/project-config.json'
import LotUtilsMixin from '~/mixins/LotUtilsMixin'
import globalStyling from '~/mixins/globalStyling'

@Component({
  components: {
    LotImage,
  },
  computed: {
    ...mapGetters('consumer-map', {
      isCondoFilteringEnabled: 'isCondoFilteringEnabled',
    }),
  },
  mixins: [LotUtilsMixin, globalStyling],
})
export default class MapCardInfo extends mixins(LotUtilsMixin, globalStyling) {
  @Prop({ default: (): LotInfo => null })
  lotInfo: LotInfo

  lotType: string = ''

  isCondoFilteringEnabled: boolean
  @Prop({ default: null }) project: PublicProject

  mounted(): void {
    this.lotType = this.getLotType(this.project, this.lotInfo)
  }

  get formattedSize(): string {
    return this.lotInfo.size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  get customPriceLabel(): string {
    if (this.lotInfo?.property_type === 'Condo') {
      const label = projectConfig[this.$route.params.slug]?.condoPriceLabel
      if (label) return label
    }
    if (this.lotType === 'home site')
      return (
        projectConfig[this.project.slug]?.homesitePriceLabel || 'Starting Price'
      )

    return projectConfig[this.project.slug]?.homePriceLabel || 'Listing Price'
  }

  get planName(): string {
    return this.lotInfo.architectural_submission?.master_plan?.plan?.name || '-'
  }

  get elevationName(): string {
    return this.lotInfo.architectural_submission?.master_plan?.name || '-'
  }

  get tag(): string {
    if (typeof this.lotInfo.builder === 'string') return 'unassigned'
    else if (this.lotInfo.status === 'coming soon') return 'coming soon'
    else if (this.lotType === 'home site') {
      if (this.lotInfo.status === 'custom') return 'custom lot'
      else if (this.lotInfo.high_profile) return 'high profile'
    } else if (this.lotType === 'home') {
      if (this.lotInfo.status === 'model') return 'model home'
      else if (this.lotInfo.sale_id) return 'sold'
    }
  }

  lotPrice(lotInfo: any, lotType: string) {
    const price = this.price(lotInfo, lotType)
    const callForDetailsLabel =
      projectConfig[this.project.slug]?.callForDetailsLabel || ''
    if (price === 'Call for Details') {
      return callForDetailsLabel || price
    }
    return price
  }

  get builderName(): string {
    return this.lotInfo.builder?.name || 'Unassigned'
  }

  displayTitle() {
    if (
      this.lotInfo.property_type === 'Condo' &&
      this.isCondoFilteringEnabled
    ) {
      return this.lotInfo.building_tooltip_title
    }
    return this.lotInfo.title
  }

  handleMouseLeave() {
    this.$emit('tooltipMouseLeave')
  }
}
